
<qbe-animation-loader name="apartment-building" width="30%"></qbe-animation-loader>
<h2 *ngIf="sharedService.loadingStep && sharedService.loadingStep.title">
  {{sharedService.loadingStep && sharedService.loadingStep.title | translate}}</h2>
<h4 *ngIf="sharedService.loadingStep && sharedService.loadingStep.subTitle">
  {{sharedService.loadingStep && sharedService.loadingStep.subTitle | translate}}</h4>
<h2 *ngIf="title?.title">
  {{title.title | translate}}</h2>
<h4 *ngIf="title?.subTitle">
  {{title.subTitle | translate}}</h4>
  <qbe-illustration *ngIf="sharedService?.loadingStep?.image || title?.image" class="loadingOffer"
  [name]="sharedService?.loadingStep?.image || title?.image" style="position: absolute; bottom: 0; left: 0;"
></qbe-illustration>
